import useApi from '../utils/axios-pettitions';
import { useAppSelector } from '../contexts/hooks';
import { newToast } from '../components';
import { MedicionQcDTO, CreateMedicionQcDTO, UpdateMedicionQcDTO, ValidateMedicionDTO, ViolacionQcDTO, ResolveViolacionDTO, LeveyJenningsDataDTO } from '../types/types.qualityControl';

export const useApiMeasurementsQC = () => {
  const { runApi } = useApi();
  const userId = useAppSelector((state) => state.userInfo.User?.Us_Id);

  //#region Mediciones

  const registerMeasurement = async (medicion: Omit<CreateMedicionQcDTO, 'Qcme_Us_Id'>) => {
    if (!userId) {
      newToast('ERROR', 'No se pudo identificar el usuario', 5);
      return null;
    }

    const data: CreateMedicionQcDTO = {
      ...medicion,
      Qcme_Us_Id: userId,
    };

    return runApi('qualitymeasurements/registerMeasurement', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 105) {
        newToast('SUCCESS', res.message, 3);
        return res.data as MedicionQcDTO;
      }
      return null;
    });
  };

  const updateMeasurement = async (medicion: Omit<UpdateMedicionQcDTO, 'Qcme_Us_Id'>) => {
    if (!userId) {
      newToast('ERROR', 'No se pudo identificar el usuario', 5);
      return null;
    }

    const data: UpdateMedicionQcDTO = {
      ...medicion,
      Qcme_Us_Id: userId,
    };



    return runApi('qualitymeasurements/updateMeasurement', 'POST', null, data).then((res) => {
      if (res.internalCode >= 200) {

        return null;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return res.data as MedicionQcDTO;
      }
      return null;
    });
  };

  const getMeasurementById = async (id: number) => {
    return runApi('qualitymeasurements/getMeasurementById', 'GET', { id }, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data as MedicionQcDTO;
      }
      return null;
    });
  };

  const getMeasurementsByConfiguration = async (configuracionId: number, cantidad: number = 20) => {
    return runApi('qualitymeasurements/getMeasurementsByConfiguration', 'GET', { configuracionId, cantidad }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data as MedicionQcDTO[];
      }
      return [];
    });
  };

  const getPendingReviewMeasurements = async (sedeId?: number, analitoId?: number) => {
    return runApi('qualitymeasurements/getPendingReviewMeasurements', 'GET', { sedeId, analitoId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data as MedicionQcDTO[];
      }
      return [];
    });
  };

  //#endregion

  //#region Validación Manual

  const validateMeasurement = async (id: number, comentario?: string) => {
    if (!userId) {
      newToast('ERROR', 'No se pudo identificar el usuario', 5);
      return false;
    }

    const data: ValidateMedicionDTO = {
      Qcme_ComentarioValidacion: comentario,
      Qcme_UsValidacion_Id: userId,
    };

    return runApi('qualitymeasurements/validateMeasurement', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  const rejectMeasurement = async (id: number, comentario?: string) => {
    if (!userId) {
      newToast('ERROR', 'No se pudo identificar el usuario', 5);
      return false;
    }

    const data: ValidateMedicionDTO = {
      Qcme_ComentarioValidacion: comentario,
      Qcme_UsValidacion_Id: userId,
    };

    return runApi('qualitymeasurements/rejectMeasurement', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  //#endregion

  //#region Violaciones Westgard

  const getViolationsByMeasurement = async (medicionId: number) => {
    return runApi('qualitymeasurements/getViolationsByMeasurement', 'GET', { medicionId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data as ViolacionQcDTO[];
      }
      return [];
    });
  };

  const getPendingViolations = async (sedeId?: number) => {
    return runApi('qualitymeasurements/getPendingViolations', 'GET', { sedeId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return [];
      } else if (res.internalCode === 101) {
        return res.data as ViolacionQcDTO[];
      }
      return [];
    });
  };

  const resolveViolation = async (id: number, accion: string) => {
    if (!userId) {
      newToast('ERROR', 'No se pudo identificar el usuario', 5);
      return false;
    }

    const data: ResolveViolacionDTO = {
      Qcv_Accion: accion,
      Qcv_Us_Id: userId,
    };

    return runApi('qualitymeasurements/resolveViolation', 'POST', { id }, data).then((res) => {
      if (res.internalCode >= 200) {
        return false;
      } else if (res.internalCode === 107) {
        newToast('SUCCESS', res.message, 3);
        return true;
      }
      return false;
    });
  };

  //#endregion

  //#region Gráficos

  const getLeveyJenningsData = async (configuracionId: number) => {
    return runApi('qualitymeasurements/getLeveyJenningsData', 'GET', { configuracionId }, null).then((res) => {
      if (res.internalCode >= 200) {
        return null;
      } else if (res.internalCode === 101) {
        return res.data as LeveyJenningsDataDTO;
      }
      return null;
    });
  };

  //#endregion

  return {
    registerMeasurement,
    updateMeasurement,
    getMeasurementById,
    getMeasurementsByConfiguration,
    getPendingReviewMeasurements,
    validateMeasurement,
    rejectMeasurement,
    getViolationsByMeasurement,
    getPendingViolations,
    resolveViolation,
    getLeveyJenningsData,
  };
};
